import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Redirect component for legacy /creator/:handle routes
export const CreatorRedirect = () => {
  const { handle } = useParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate(`/u/${handle}`, { replace: true });
  }, [handle, navigate]);
  
  return null;
};

// Redirect component for legacy /reader/:handle routes
export const ReaderRedirect = () => {
  const { handle } = useParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate(`/u/${handle}`, { replace: true });
  }, [handle, navigate]);
  
  return null;
};

// Redirect component for legacy /user/:handle routes
export const UserRedirect = () => {
  const { handle } = useParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate(`/u/${handle}`, { replace: true });
  }, [handle, navigate]);
  
  return null;
};

// Redirect component for @handle routes
export const AtHandleRedirect = () => {
  const { handle } = useParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Remove @ if present
    const cleanHandle = handle.replace('@', '');
    navigate(`/u/${cleanHandle}`, { replace: true });
  }, [handle, navigate]);
  
  return null;
};
